module.exports = __webpack_public_path__ + "static/media/adviesbox-logo.7084db82.svg";